<div id="ht">
  <div id="main-cnt">

      <ion-content class="main-content">
          <div class="scroller-container">
              <div class="content-scroller">
                  <div class="content">
                      <!-- edit da qui... -->
                      <form (ngSubmit)="saveTeam()" [formGroup]="teamForm">
                        <ion-input placeholder="Name" class="text-input" formControlName="name" type="text"></ion-input>
                        <ion-textarea placeholder="Description" class="text-input" formControlName="description"></ion-textarea>
                        
                        <br>
                        <button expand="block" type="submit" class="button glass-blurred-background drop-shadow padding">{{ saveTeamButtonText }}</button>
                      </form>
                      <!-- ...a qui -->
                  </div>
              </div>
          </div>
      </ion-content>

  </div>
</div>



<!-- 


<ion-header>
  <ion-toolbar>
    <div class="modal-top"></div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding model-content">
  <form (ngSubmit)="saveTeam()" [formGroup]="teamForm">
    <ion-list class="inputLabel">
      <ion-item class="inputItem" detail="false">
        <ion-label class="addInput-Label" position="floating">Name</ion-label>
        <ion-input class="addInput" formControlName="name" type="text"></ion-input>
      </ion-item>
      <ion-item class="inputItem" detail="false">
        <ion-label class="addInput-Label" position="floating">Description</ion-label>
        <ion-textarea class="addInput" formControlName="description"></ion-textarea>
      </ion-item>
    </ion-list>
    <ion-button expand="block" type="submit" class="loginButton">{{ saveTeamButtonText }}</ion-button>
  </form>
</ion-content> -->
